import { ChatDocument } from '@models/chat';
import { onSnapshot } from 'firebase/firestore';
import { useState, useMemo, useEffect } from 'react';
import { getChatsByUidQuery } from '@util/firestore/messages/';
import { UserDocument } from 'models/user';

const useRealtimeChats = (
  userDoc?: UserDocument | null | undefined,
  variant?: 'messages' | 'offers' | 'orderDetail' | 'experts'
) => {
  const [realtimeChats, setChats] = useState<ChatDocument[] | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState(false);

  const chatsQuery = useMemo(
    () => (!userDoc ? null : getChatsByUidQuery(userDoc, variant)),
    [userDoc, variant]
  );

  useEffect(() => {
    if (!chatsQuery) return;

    setIsLoading(true);

    const unsubscribe = onSnapshot(chatsQuery, (snapshot) => {
      const realTimeData = snapshot.docs.map((doc) => doc.data());
      setChats(realTimeData);
      setIsLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, [chatsQuery]);

  return {
    realtimeChats,
    isLoading,
  };
};

export default useRealtimeChats;
